var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourceSingleOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 7.6707L8.85945 4.66597L9.71944 4.00001L4.99998 0.329315L0.280518 4.00001L1.13526 4.66597L4.99998 7.6707ZM4.99998 1.65601L8.00994 4.00001L4.99998 6.344L1.99001 4.00001L4.99998 1.65601Z",
    fill: "#64748D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceSingleOutlined);
export default __webpack_public_path__ + "static/media/sourceSingleOutlined.40003b76a8dc5e3f1f0b74125cddc067.svg";
export { ForwardRef as ReactComponent };